import { FormationDetailProps } from "@/types/formation";

export const portHarnaisAntichutesFormation: FormationDetailProps = {
  id: "17",
  title: "Formation Port du Harnais et Utilisation de Systèmes Antichute Fixes",
  description: "Formation permettant d'acquérir les compétences nécessaires pour travailler en hauteur en utilisant des systèmes de protection contre les chutes.",
  duration: "7 heures (1 jour)",
  category: "Travail en Hauteur",
  imageSrc: "/images/formations/harnaisfiche.webp",
  slug: "port-harnais-systemes-antichute",
  reference: "F-PHUSAF",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne amenée à porter et utiliser un harnais pour un travail en hauteur en situation simple",
  prerequisites: [
    "Être reconnu médicalement apte au travail en hauteur et en bonne condition physique, ne pas avoir d'appréhension du vide",
    "Avoir à sa disposition des EPI adaptés au travail et à l'environnement",
    "Maîtriser la langue française pour une bonne compréhension"
  ],
  objectives: [
    "Acquérir les règles de choix du harnais selon les différentes situations (utilisation simple)",
    "Être capable d'identifier les règlementations et les principes de base du travail en hauteur",
    "Être capable d'utiliser correctement le harnais et utiliser les facteurs sécurité",
    "S'assurer du facteur de sécurité en utilisant un système de sécurité lors permettant d'obtenir avec un facteur de chute inférieur à 1",
    "Adapter son poste de vigilance vis-à-vis de soi et de ses partenaires"
  ],
  program: [
    {
      title: "Partie théorique",
      items: [
        "Statistiques chutes, les risques de travail en hauteur et leurs facteurs aggravants (statistiques des chutes)",
        "Réglementation",
        "Les principes généraux de prévention, le Décret 2004-924 (articles spécifiques), les droits, les devoirs et responsabilités de chacun",
        "Le travail en hauteur sous ses aspects réglementaires et textes",
        "Analyse des risques spécifiques de travail en hauteur",
        "Prévention : attitude des facteurs fondamentaux (choix du site et facteurs de chute, force d'un arrêt et effet pendulaire)",
        "La méthode logique d'intervention et d'organisation du travail en situation à petit plus chutes",
        "La protection collective contre les chutes de hauteur",
        "Définition de la protection collective et différentiation de la protection individuelle",
        "Les points d'ancrage et les lignes de vies temporaires et fixes",
        "Définition de la protection individuelle, présentation du harnais et des systèmes antichute à domaine sur le lieu d'intervention"
      ]
    },
    {
      title: "Partie pratique",
      items: [
        "L'objectif est de maîtriser l'utilisation des EPI contre les chutes de hauteur dans une situation de travail sécurisé pratique",
        "Contrôle et ajustement du harnais à sa morphologie",
        "Les accessoires à utiliser pour le travailleur (antichute, ligne de vie, ancrages, stop chute, connecteurs) : choix du type d'ancrage du harnais et déterminer quel est le plus adapté selon la situation de travail",
        "Liaison antichute",
        "Mise en œuvre lors de la liaison antichute en adaptant les facteurs de sécurité",
        "Identification des risques induits par son utilisation selon l'environnement",
        "Ancrages fixes",
        "Installation et utilisation de dispositif d'ancrage mobile",
        "Exercices pratiques de mise en situation réelle de travail en fonction des problématiques spécifiques au site, mise en application des procédures évolutives dans l'entreprise (permis de travail en hauteur : ...) etc."
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, exercice sur site",
    "Support techniques, textes réglementaires et normatifs EPI contre les chutes de hauteur"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par évaluation des acquis.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
